import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-fcsc-upload-vorab-alert',
  templateUrl: './fcsc-upload-vorab-alert.component.html',
  styleUrls: ['./fcsc-upload-vorab-alert.component.scss'],
})
export class FcscUploadVorabAlertComponent {
  @Input() message!: string;
  title = 'Alert';

  constructor(public readonly activeModal: NgbActiveModal) {}
}
